import React from 'react';

export interface SecurityStatsCardsProps {
  stats: {
    total: number;
    bySeverity: Array<{ severity: string; count: number }>;
  };
}

const SecurityLogsStatsCards: React.FC<SecurityStatsCardsProps> = ({ stats }) => {
  const sev = (label: string) => stats.bySeverity.find((s) => s.severity === label)?.count || 0;

  const cards = [
    { label: 'Total (7 jours)', value: stats.total, tone: 'border-sky-500/30 bg-sky-500/10', textColor: 'text-sky-300', numColor: 'text-cockpit-text' },
    { label: 'Critiques', value: sev('critical'), tone: 'border-red-500/30 bg-red-500/10', textColor: 'text-red-300', numColor: 'text-cockpit-text' },
    { label: 'Élevés', value: sev('high'), tone: 'border-orange-500/30 bg-orange-500/10', textColor: 'text-orange-300', numColor: 'text-cockpit-text' },
    { label: 'Moyens', value: sev('medium'), tone: 'border-amber-500/30 bg-amber-500/10', textColor: 'text-amber-300', numColor: 'text-cockpit-text' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
      {cards.map((c) => (
        <div key={c.label} className={`rounded-xl border ${c.tone} p-4 backdrop-blur-sm`}>
          <p className={`text-xs font-medium mb-1 ${c.textColor}`}>{c.label}</p>
          <p className={`text-3xl font-bold ${c.numColor}`}>{c.value}</p>
        </div>
      ))}
    </div>
  );
};

export default SecurityLogsStatsCards;
